import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon } from 'lucide-react';
import { usePlatform } from '../../context/PlatformContext';
export type SeriesStatus = 'ongoing' | 'complete' | 'backlist' | 'hiatus' | 'cancelled' | 'spin_off_active';
interface SeriesStatusBadgeProps {
  status: string;
  completedDate?: string;
  spinOffName?: string;
  spinOffId?: string;
  size?: 'sm' | 'md';
  className?: string;
}
export const SeriesStatusBadge: React.FC<SeriesStatusBadgeProps> = ({
  status,
  completedDate,
  spinOffName,
  spinOffId,
  size = 'md',
  className = ''
}) => {
  // Normalize status
  let normalizedStatus: SeriesStatus = 'ongoing';
  const statusLower = status?.toLowerCase() || '';
  if (statusLower.includes('ongoing')) normalizedStatus = 'ongoing';else if (statusLower.includes('complete')) normalizedStatus = 'complete';else if (statusLower.includes('backlist')) normalizedStatus = 'backlist';else if (statusLower.includes('hiatus') || statusLower.includes('paused')) normalizedStatus = 'hiatus';else if (statusLower.includes('cancel') || statusLower.includes('discontinued')) normalizedStatus = 'cancelled';else if (statusLower.includes('spin')) normalizedStatus = 'spin_off_active';
  // Check date for complete vs backlist logic
  if (normalizedStatus === 'complete' && completedDate) {
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    const compDate = new Date(completedDate);
    if (compDate < sixMonthsAgo) {
      normalizedStatus = 'backlist';
    }
  }
  // Size classes — use text-xs for both sizes so height matches genre tags
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1';
  // Config map - Solid colors, no icons
  const config = {
    ongoing: {
      color: 'bg-blue-600 text-white',
      label: 'Ongoing'
    },
    complete: {
      color: 'bg-green-600 text-white',
      label: 'Complete'
    },
    backlist: {
      color: 'bg-slate-600 text-white',
      label: 'Backlist'
    },
    hiatus: {
      color: 'bg-amber-500 text-white',
      label: 'Hiatus'
    },
    cancelled: {
      color: 'bg-red-600 text-white',
      label: 'Discontinued'
    },
    spin_off_active: {
      color: 'bg-fuchsia-600 text-white',
      label: 'Spin-Off Active'
    }
  };
  const {
    isAfterTide
  } = usePlatform();
  const badgeRadius = isAfterTide ? 'rounded-sm' : 'rounded-full';
  const currentConfig = config[normalizedStatus];
  // Special render for spin-off with link
  if (normalizedStatus === 'spin_off_active' && spinOffName && spinOffId) {
    return <Link to={`/series/${spinOffId}`} className={`inline-flex items-center ${badgeRadius} font-medium transition-colors hover:opacity-90 ${sizeClasses} ${currentConfig.color} ${className}`} onClick={e => e.stopPropagation()} data-id="element-1049" data-mp="2v74r4sw9o376">
        <SparklesIcon className="h-3 w-3 mr-1" data-id="element-1050" data-mp="14tnq7dt46nua" />
        Spin-Off: {spinOffName} →
      </Link>;
  }
  return <span className={`inline-flex items-center ${badgeRadius} font-medium leading-none whitespace-nowrap ${sizeClasses} ${currentConfig.color} ${className}`} data-id="element-1051" data-mp="xbpv4ebojfal">
      {currentConfig.label}
    </span>;
};